import { render, staticRenderFns } from "./nationalEvents.vue?vue&type=template&id=719c1606&scoped=true&"
import script from "./nationalEvents.vue?vue&type=script&lang=js&"
export * from "./nationalEvents.vue?vue&type=script&lang=js&"
import style0 from "./nationalEvents.vue?vue&type=style&index=0&id=719c1606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719c1606",
  null
  
)

export default component.exports